import React, { useState } from "react"
import { Button, Chip, TextField, Typography } from "@mui/material"
import { CATEGORIES as predefinedTags } from "../constants"

const TagSelector = ({ selectedTags, setSelectedTags }) => {
  const [customTag, setCustomTag] = useState("")

  const handleTagClick = (tag) => {
    if (selectedTags.includes(tag)) {
      setSelectedTags(selectedTags.filter((selectedTag) => selectedTag !== tag))
    } else {
      if (selectedTags.length < 3) {
        setSelectedTags([...selectedTags, tag])
      } else {
        alert("You can only select up to 3 tags.")
      }
    }
  }

  const handleAddCustomTag = () => {
    if (customTag && !selectedTags.includes(customTag)) {
      if (selectedTags.length < 3) {
        setSelectedTags([...selectedTags, customTag])
        setCustomTag("")
      } else {
        alert("You can only select up to 3 tags.")
      }
    }
  }

  return (
    <div style={{ width: 400 }}>
      <Typography variant="h6" gutterBottom sx={{ fontSize: "1rem" }}>
        Popular Tags
      </Typography>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "8px",
          marginBottom: "16px",
        }}
      >
        {predefinedTags
          .filter((tag) => tag !== "Featured")
          .map((tag) => (
            <Chip
              key={tag}
              label={tag}
              onClick={() => handleTagClick(tag)}
              color={selectedTags.includes(tag) ? "primary" : "default"}
              style={{ cursor: "pointer" }}
            />
          ))}
      </div>
      <TextField
        value={customTag}
        onChange={(e) => setCustomTag(e.target.value)}
        label="Custom Tag"
        variant="outlined"
        placeholder="Type a custom tag"
        style={{ marginBottom: "16px" }}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault()
            handleAddCustomTag()
          }
        }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddCustomTag}
        style={{ marginBottom: "16px", padding: "16px", marginLeft: "5px" }}
      >
        Add Tag
      </Button>

      {selectedTags.length > 0 && (
        <Typography variant="h6" gutterBottom sx={{ fontSize: "1rem" }}>
          Selected Tags
        </Typography>
      )}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
        {selectedTags.map((tag) => (
          <Chip
            key={tag}
            label={tag}
            onDelete={() =>
              setSelectedTags(
                selectedTags.filter((selectedTag) => selectedTag !== tag)
              )
            }
          />
        ))}
      </div>
    </div>
  )
}

export default TagSelector
